import { useEffect, useState, useMemo } from "react";

export const FilterOptions = (props) => {
    const [options, setOptions] = useState([]);

    const filterOptions = useMemo(() => {
        var newOptionState = [];
        
        if (props.filter.multiple) {
            //Checkboxes
            for (let _i = 0; _i < props.filter.options.length; _i++) {
                const o = props.filter.options[_i];
                const id = "cb_" + props.filter.contentUId + "_" + o;
                newOptionState.push(
                    <div key={props.filter.contentUId + "_" + _i} className="c-input__group">
                        <input id={id} value={o} defaultChecked={props.filter.values.includes(o)} type={"checkbox"} onChange={(evt) => {
                            if (evt.target.checked) {
                                props.filter.values.push(o);
                            }
                            else {
                                props.filter.values = props.filter.values.filter(v => v !== o);
                            }
                            let newState = { ...props.ficheData };
                            props.setFicheData(prev => {
                                return {
                                    ...prev,
                                    filter: newState.filter
                                }
                            });
                        }} />
                        <label htmlFor={id}>{o}</label>
                    </div>
                );
            };
        }
        else {
            //Radiobuttons
            if(props.filter.defaultValue){
                const id = "cb_" + props.filter.contentUId + "_default";
                const name = "cb_" + props.filter.contentUId;
                newOptionState.push(
                    <div key={props.filter.contentUId + "_default"} className="c-radio">
                        <label htmlFor={id}>
                            <input id={id} name={name} value={""} type="radio" defaultChecked={true}
                                onChange={(evt) => {
                                    props.filter.values = [];
                                    if (evt.target.checked) {
                                        props.filter.values.push("");
                                    }
                                    else {
                                        props.filter.values = props.filter.values.filter(v => v !== "");
                                    }
                                    let newState = { ...props.ficheData };
                                    props.setFicheData(prev => {
                                        return {
                                            ...prev,
                                            filter: newState.filter
                                        }
                                    });
                                }} />
                            {props.filter.defaultValue}</label>
                    </div>
                );
            }

            for (let _i = 0; _i < props.filter.options.length; _i++) {
                const o = props.filter.options[_i];
                const id = "cb_" + props.filter.contentUId + "_" + o;
                const name = "cb_" + props.filter.contentUId;
                newOptionState.push(
                    <div key={props.filter.contentUId + "_" + _i} className="c-radio">
                        <label htmlFor={id}>
                            <input id={id} name={name} value={o} type="radio"
                                onChange={(evt) => {
                                    props.filter.values = [];
                                    if (evt.target.checked) {
                                        props.filter.values.push(o);
                                    }
                                    else {
                                        props.filter.values = props.filter.values.filter(v => v !== o);
                                    }
                                    let newState = { ...props.ficheData };
                                    props.setFicheData(prev => {
                                        return {
                                            ...prev,
                                            filter: newState.filter
                                        }
                                    });
                                }} />
                            {o}</label>
                    </div>
                );
            };
        };
        return newOptionState;
    }, [JSON.stringify(props.filter.options)])

    return <div className={`col-sm-${props.filter.gridWidth != 0 ? props.filter.gridWidth : 4}`}>
        <strong>{props.filter.title}</strong>
        {filterOptions}
    </div>;
}